import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=0a2cfb5c&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"
import style0 from "./Chat.vue?vue&type=style&index=0&id=0a2cfb5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2cfb5c",
  null
  
)

export default component.exports